import service from './axios';

// 获取兑换商品列表
export const fetchExchangeProductsList = (params) => {
  return service({
    method: 'get',
    url: '/manage/products',
    params
  });
};

// 获取兑换商品详情
export const fetchExchangeProductDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/products/${id}`
  });
};

// 创建兑换商品
export const createExchangeProduct = (data) => {
  return service({
    method: 'post',
    url: '/manage/products',
    data
  });
};

// 更新兑换商品
export const updateExchangeProduct = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/products/${id}`,
    data
  });
};

// 删除兑换商品
export const deleteExchangeProduct = (id) => {
  return service({
    method: 'delete',
    url: `/manage/products/${id}`
  });
};

// 更新商品状态
export const updateProductStatus = (id, status) => {
  return service({
    method: 'put',
    url: `/manage/products/${id}`,
    data: { status }
  });
};

// 更新商品推荐状态
export const updateRecommendationStatus = (id, isRecommended) => {
  return service({
    method: 'put',
    url: `/manage/products/${id}`,
    data: { is_recommended: isRecommended }
  });
};

// 获取商品分类
export const fetchProductCategories = () => {
  return service({
    method: 'get',
    url: '/manage/product-categories'
  });
};